<template>
  <h3 class="header" :style="headerElStyles" v-html="header.text"></h3>
</template>

<script>
export default {
  name: "CardUIHeader",
  props: {
    header: {
      type: Object,
      default() {},
    },
  },
  computed: {
    headerElStyles() {
      const { isTextInCaps, textColor } = this.header;

      // direct styles
      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  font-style: normal;
  hyphens: auto;
  overflow-wrap: anywhere;

  @include font-family("heading");
  @include scale-fonts("heading-3");
  @include setup-richtext();
}
</style>
